import TimeAgo from "javascript-time-ago";
import { Month } from "../enums/Month";
import en from 'javascript-time-ago/locale/en.json'

//translations
import localisation from '../services/localisation';
import IL from '../interfaces/localisation';



type timeStyle = "full" | "long" | "medium" | "short" | undefined
type dateStyle = "full" | "long" | "medium" | "short" | undefined

export function getDateGreeting(time: Date, name: string): string {

    const hours = time.getHours();
    if (hours >= 0 && hours <= 11) {
        return `${localisation.getLocalString(IL["Locker.GoodMorning"])} ${name}`;
    }
    else if (hours >= 12 && hours <= 17 ) {
        return `${localisation.getLocalString(IL["Locker.GoodAfternoon"])} ${name}`;
    }
    else {
        return `${localisation.getLocalString(IL["Locker.GoodEvening"])} ${name}`;
    }
}

export function getMonthFromEnum(month: Month) {
    return [
        "unknown",
        localisation.getLocalString(IL["Month.January"]),
        localisation.getLocalString(IL["Month.February"]),
        localisation.getLocalString(IL["Month.March"]),
        localisation.getLocalString(IL["Month.April"]),
        localisation.getLocalString(IL["Month.May"]),
        localisation.getLocalString(IL["Month.June"]),
        localisation.getLocalString(IL["Month.July"]),
        localisation.getLocalString(IL["Month.August"]),
        localisation.getLocalString(IL["Month.September"]),
        localisation.getLocalString(IL["Month.October"]),
        localisation.getLocalString(IL["Month.November"]),
        localisation.getLocalString(IL["Month.December"]),
    ][month];
}

export function formatTimeToMinutesAndSeconds(s: number) {

    const timeLeft = {
        minute: '0',
        second: '0'
    }
    const dtFormat = new Intl.DateTimeFormat(undefined, {
        timeStyle: 'medium',
        timeZone: 'UTC'
    })

    dtFormat.formatToParts(new Date(s)).forEach(({type, value})=> {
        if(type === 'minute' || type === 'second') {
            timeLeft[type] = value
        }
    })

    return `${timeLeft.minute}:${timeLeft.second}`;
}

export function dateAgo(date:Date):string {


    TimeAgo.addLocale(en);
    const timeAgo = new TimeAgo('en-GB');

    return  String(timeAgo.format(new Date(date.toString())))
    .replace('ago', '')
    .replace('just now',localisation.getLocalString(IL['Date.JustNow']))
    .replace('minutes',localisation.getLocalString(IL['Date.Mins']))
    .replace('minute', localisation.getLocalString(IL['Date.Min']))
    .replace('seconds', localisation.getLocalString(IL['Date.Sec']))
    .replace('hours', localisation.getLocalString(IL['Date.Hours']))
    .replace('hour', localisation.getLocalString(IL['Date.Hour']))
    .replace('days', localisation.getLocalString(IL['Date.Days']))
    .replace('day', localisation.getLocalString(IL['Date.Day']))
    .replace('week', localisation.getLocalString(IL['Date.Week']))
    .replace('weeks', localisation.getLocalString(IL['Date.Weeks']))
    .replace('months', localisation.getLocalString(IL['Date.Months']))
    .replace('month', localisation.getLocalString(IL['Date.Month']))
    .replace('years', localisation.getLocalString(IL['Date.Years']))
    .replace('year', localisation.getLocalString(IL['Date.Year']))
    .trim(); 
}

export function addDays(days:number, startDate:Date) {
    const date = new Date(startDate);
    date.setDate(date.getDate() + days);
    return date;
}

export function getDuration(st: string | number, et: string | number, timeStyle: timeStyle = 'short'){
    const startTime = new Intl.DateTimeFormat(undefined, {timeStyle: timeStyle, hour12:false }).format(new Date(st));
    const endTime = new Intl.DateTimeFormat(undefined, {timeStyle: timeStyle, hour12:false }).format(new Date(et));

    return `${startTime} - ${endTime}`.toLocaleUpperCase();
}

export function getStartDate(st:string, dateStyle:dateStyle = 'long'){
    return new Intl.DateTimeFormat(undefined, {dateStyle: dateStyle }).format(new Date(st));
}

export function getRelativeDate(date: Date) {
    
    const rtf1 = new Intl.RelativeTimeFormat(undefined , { style: 'long' });

    const now = new Date()
    
    const diff = (now.getTime()-date.getTime());
    const threshold = (1000 * 60 * 60 * 24) * 6; //6 days

    const minute = 60;
    const hour = minute * 60;
    const day = hour * 24;
    const week = day * 7;

    if(diff > threshold){
        if(window.navigator.language == "en"){
            let ye = new Intl.DateTimeFormat('en', { year: '2-digit' }).format(date);
            let mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(date);
            let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
            
            if(now.getFullYear() == date.getFullYear()){
                return `${da} ${mo}`;
            }
            
            return `${da} ${mo} ${ye}`;

        }else{
            return new Intl.DateTimeFormat().format(date);
        }
    }
    
    const relativeDiff = diff / 1000 
    
    if (relativeDiff < minute) {
        return localisation.getLocalString(IL["Date.Now"]);
      } else if (relativeDiff < hour) {
        return rtf1.format(-(relativeDiff  / minute), 'minute')
      } else if (relativeDiff < day) {
        return rtf1.format(-(relativeDiff  / hour), 'hour')
      } else if (relativeDiff < week) {
        return rtf1.format(-(relativeDiff  / day), 'day')
      } 
}
export function getTimeFromDate(t: Date) {
    return new Intl.DateTimeFormat(undefined, {hour12:false, timeStyle:'short' }).format(t);
}



export function getStartOfDay() {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate()).toISOString();
}

export function parseDateFromString(inputString: string): Date | undefined {
    const dateRegex = /(\d{4}-\d{2}-\d{2}T\s?\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:[+-]\d{2}:\d{2})?)/;
    const match = inputString.match(dateRegex);
  
    if (match && match[1]) {
      const dateString = match[1].replace(/\s*T\s*/, "T");
      const parsedDate = new Date(dateString);
  
      if (!isNaN(parsedDate.getTime())) {
        return parsedDate;
      } else {
        console.error(localisation.getLocalString(IL["Errors.Error"]), dateString);
      }
    }
  
    return undefined;
}
  
export function formatToDDMMYYYY(isoString: string): string {
  if(!isoString) {
    return '-'
  }
  const date = new Date(isoString);

  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();

  return `${day}/${month}/${year}`;
}

export function hasDateOccurred(date: Date) {
    return date.getTime() <= Date.now()
}
